import { Box } from '@mantine/core';

import { Declaration } from '@e-origin/shared';

import { IconFactory } from '@assets';
import { IconBox } from '@components';
import { extractDeclarationStatusByIcon } from './utils';

interface DeclarationHVStatusIndicatorProps {
  declaration: Declaration;
}

export const DeclarationHVStatusIndicator: React.FC<DeclarationHVStatusIndicatorProps> = (props) => {
  const {
    declaration: { goodShipmentGlobal, generalInfo },
  } = props;

  const hasAnomaliesDetectedDescription = goodShipmentGlobal?.anomaliesDetected && goodShipmentGlobal?.webMatchingDescription === false;

  const hasAnomaliesDetectedHSCode = goodShipmentGlobal?.anomaliesDetected && goodShipmentGlobal?.hsDescriptionOK === false;

  const hasAnomaliesDetectedValue = goodShipmentGlobal?.invoicedRateWebOK === false;

  const hasAnomaliesDetectedAllHandledByUser =
    goodShipmentGlobal?.anomaliesDetected &&
    goodShipmentGlobal?.webMatchingDescription &&
    goodShipmentGlobal?.hsDescriptionOK &&
    goodShipmentGlobal?.invoicedRateWebOK;

  const hasNoAnomaliesDetected = generalInfo.complianceCheck && goodShipmentGlobal?.anomaliesDetected === false;

  const hasNoRiskAnalysisDone = generalInfo.complianceCheck === false;

  return (
    <Box display={'flex'}>
      {hasAnomaliesDetectedValue && (
        <IconBox icon={IconFactory.anomalyValue} alt={'anomalies-detected-value'} title={extractDeclarationStatusByIcon(IconFactory.anomalyValue)} />
      )}
      {(hasAnomaliesDetectedDescription || hasAnomaliesDetectedHSCode) && (
        <IconBox
          icon={IconFactory.anomaliesHSCodeOrDescription}
          alt={'anomalies-detected-HS-code-or-description'}
          title={extractDeclarationStatusByIcon(IconFactory.anomaliesHSCodeOrDescription)}
        />
      )}
      {hasNoAnomaliesDetected && (
        <IconBox icon={IconFactory.noSentAnomalies} alt={'no-anomalies-detected'} title={extractDeclarationStatusByIcon(IconFactory.noSentAnomalies)} />
      )}
      {hasAnomaliesDetectedAllHandledByUser && (
        <IconBox
          icon={IconFactory.anomaliesHandled}
          alt={'anomalies-detected-all-handled-by-user'}
          title={extractDeclarationStatusByIcon(IconFactory.anomaliesHandled)}
        />
      )}
      {hasNoRiskAnalysisDone && (
        <IconBox icon={IconFactory.notSent} alt={'no-risk-analysis-done'} title={extractDeclarationStatusByIcon(IconFactory.notSent)} />
      )}
    </Box>
  );
};
